import { withInstall } from '@vuesax-plus/utils'
import check from './src/check.vue'

export const IconCheck = withInstall(check)
export default IconCheck

export * from './src/check'
